import React, { useEffect, useState } from "react";
import { formatMessageTime } from "../../../../services/coral/coral-utils";
import "./groups-list.scss";

// Utility functions
const getInitials = (name) => {
  return name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
};

const GroupsList = ({
  groups = [],
  selectedGroup,
  onGroupSelect,
  onCreateGroup,
  onOrganizationSettings,
  onShowNotifications,
  onRefreshGroups,
  notificationCount,
  loading,
  filter,
  onFilterChange,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const [, setNowTick] = useState(() => Date.now());

  useEffect(() => {
    const intervalId = setInterval(() => setNowTick(Date.now()), 30_000);
    return () => clearInterval(intervalId);
  }, []);

  // Filter groups based on search term
  const filteredGroups = groups.filter((group) =>
    (group.name || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Render Methods
  const renderHeader = () => (
    <div className="chat-search mt-0 mb-3">
      <div className="header-top">
        {/* <h2>Groups</h2> */}
        <div className="chat-new-start mb-2">
          <button type="button" className="bouncy-button small w-100" onClick={onCreateGroup}><i className="mdi mdi-plus"></i><span>Create new group</span></button>
        </div>

        <div className="d-flex align-items-center gap-1 overflow-visible mb-2">
          <div className="search-box">
            <input
              type="text"
              placeholder="Search"
              id="chat-search"
              className="form-control"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {/* <i className="fas fa-search search-icon"></i> */}
          </div>

          <div className="header-actions gap-1">
            <button
              className="bouncy-button small white notifications-btn"
              onClick={onShowNotifications}
              title="View Notifications"
            >
              <i className="fas fa-bell"></i>
              {notificationCount > 0 && (
                <span className="notification-badge">{notificationCount}</span>
              )}
            </button>
            <button
              className="bouncy-button small white refresh-btn"
              onClick={onRefreshGroups}
              title="Refresh Groups"
              disabled={loading}
            >
              <i className={`fas fa-sync-alt ${loading ? 'fa-spin' : ''}`}></i>
            </button>
            {/* <button
              className="action-btn"
              onClick={onCreateGroup}
              title="Create New Group"
            >
              <i className="fas fa-plus"></i>
            </button> */}
            <button
              className="bouncy-button small white"
              onClick={onOrganizationSettings}
              title="Organization Settings"
            >
              <i className="fas fa-cog"></i>
            </button>
          </div>
        </div>

        <div className="group-filter">
          <span>Filter: </span>
          <button type="button" className={`bouncy-button small w-100 ${filter === 'standard' ? 'secondary' : 'white'}`} onClick={() => onFilterChange("standard")}><span>Standard</span></button>
          <button type="button" className={`bouncy-button small w-100 ${filter === 'anonymous' ? 'secondary' : 'white'}`} onClick={() => onFilterChange("anonymous")}><span>Anonymous</span></button>
        </div>

      </div>
    </div>
  );

  const renderLoadingState = () => (
    <div className="thread-loader-wrapper">
      <img
        src="assets/images/ring-loader.svg"
        alt="loader"
        className="loader"
      />
    </div>
  );

  const renderEmptyState = () => (
    <div className="no-groups">
      <div className="no-groups-content">
        <i className="fas fa-users"></i>
        <p>
          {searchTerm
            ? "No groups found matching your search"
            : "No groups yet. Create your first group!"}
        </p>
      </div>
    </div>
  );

  const renderGroupItem = (group) => (
    <div
      key={group.id}
      className={`group-item ${selectedGroup?.id === group.id ? "active" : ""}`}
      onClick={() => onGroupSelect(group)}
    >
      <div className="group-info">
        <div className="group-avatar">
          {group.avatar ? (
            <img src={group.avatar} alt={group.name} />
          ) : (
            getInitials(group.name || 'Group')
          )}
        </div>
        <div className="group-details">
          <div className="group-name">{group.name || 'Unnamed Group'}</div>
          <div className="last-message">{group.lastMessage || 'No messages yet'}</div>
        </div>
        <div className="group-meta">
          <div className="last-time">
            {group.lastMessageRawTime ? formatMessageTime(group.lastMessageRawTime) : (group.lastMessageTime || '')}
          </div>
          {group.unreadCount > 0 && (
            <div className="unread-badge">{group.unreadCount}</div>
          )}
        </div>
        {group.cswOpen && <div className="group-meta">
          <i className="fa fa-clock" style={{ color: 'green' }}></i>
        </div>}
      </div>
    </div>
  );

  const renderGroupsList = () => {
    if (loading) {
      return renderLoadingState();
    }
    
    if (filteredGroups.length === 0) {
      return renderEmptyState();
    }
    
    return filteredGroups.map(renderGroupItem);
  };

  return (
    <>
      {renderHeader()}
      <div className="groups-list">
        {renderGroupsList()}
      </div>
    </>
  );
};

export default GroupsList;
